/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_RestInputs */

const en_us2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest (seconds)`)
};

const pt_br2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso (segundos)`)
};

const es_419_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso (segundos)`)
};

const pt_pt2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso (segundos)`)
};

const fr_fr2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repos (secondes)`)
};

const de_de2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause (Sekunden)`)
};

const it_it2_plan_build_dose_rest = /** @type {(inputs: Plan_Build_Dose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero (secondi)`)
};

/**
* | output |
* | --- |
* | "Rest (seconds)" |
*
* @param {Plan_Build_Dose_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_rest = /** @type {((inputs?: Plan_Build_Dose_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_rest(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_rest(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_rest(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_rest(inputs)
	return en_us2_plan_build_dose_rest(inputs)
});
export { plan_build_dose_rest as "plan-build.dose_rest" }